import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InactiveLicensesList from "../components/report/InactiveLicensesList";

const InactiveLicensesReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Inactive Licenses Report" />

        {/* InactiveLicensesList with export functionality */}
        <div className="inactive-licenses-report">
          <InactiveLicensesList />
        </div>
      </MasterLayout>
    </>
  );
};

export default InactiveLicensesReport;
